// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__30m3g","list":"BalanceDue_list__KhZ5f","listRow":"BalanceDue_listRow__1tGaV","total":"BalanceDue_total__3eWg6"};